import { Component, OnInit, Input, Output, EventEmitter, SimpleChanges, ChangeDetectionStrategy, ChangeDetectorRef } from '@angular/core';
import { Questions, SelectedOptionList, Rules } from 'src/app/common-class/questions';
import { Answers } from 'src/app/common-class/answers';
import { ParticipationDataService } from 'src/app/_services/participation-data.service';
import { PreviewData } from 'src/app/common-class/survey';
import { Group } from 'src/app/common-class/pages';
// import { threadId } from 'worker_threads';
declare var $: any;

@Component({
  selector: 'app-check-box',
  templateUrl: './check-box.component.html',
  styleUrls: ['./check-box.component.css'],
  //changeDetection: ChangeDetectionStrategy.OnPush
})

export class CheckBoxComponent implements OnInit {

  @Input() JsonData: string;
  @Input() isMandatoryUpfront: boolean;
  @Input() isDisplayQno: boolean;
  @Input() isDisplaySubQno: boolean;
  @Input() isMobile: boolean;
  @Input() isGrid: boolean;
  @Input() isNewParticipationButton: boolean;
  @Input() isStandAlone: boolean;
  @Input() group: Group;
  @Output() ChangeAnswersData: EventEmitter<Questions> = new EventEmitter<Questions>();
  @Output() ChangeLoadingAnswersData: EventEmitter<Questions> = new EventEmitter<Questions>();

  questions: Questions;
  answerImagesLength: number;
  answerLength : number;
  columnWidth: any;

  public tempArray = [];
  public answersArray: any;
  public answersArray1: any;

  selectedValueList: SelectedOptionList[] = [];

  singleImageArray: Array<number> = [];
  multiImageArray: Array<number> = [];
  isFormSubmit: boolean = false;
  isFormSubmitSub: any;
  isPreview: boolean;
  isAriaRequired: boolean = false;
  isCapchaManditorySkip: boolean;
  nextButtonClickNo: number;
  pageIsSoftRequiredHandle: any;
  nextButtonClickSub: any;
  surveyFormat: number;
  isNewParticipation: boolean;
  newParticipationBtnText: string;
  showNewParticipationButton: boolean;
  isAnsChange: boolean;
  resetPageSub: any;
  isDisplayedPipeMessage: boolean;
  AsteriskMandatory:string="";

  ngOnChanges(changes: SimpleChanges) {

    let change = changes['JsonData'];

    let curVal = JSON.stringify(change.currentValue);
    let preVal = JSON.stringify(change.previousValue);

    if (curVal != preVal && preVal != undefined) {
      this.questions = JSON.parse(this.JsonData);
      this.answerPipingMessageDisplayed();

      if (this.questions.answer_style == 1 && this.questions.RotateIndex == 0 && this.questions.Answers != null) {
        this.RandomAnswerHandling();
      }

      if (this.questions.selectedOptionList != null) {
        this.selectedValueList = this.questions.selectedOptionList;
        this.isAnsChange = true;
      }else{
        this.selectedValueList = [];
      }

      if ((this.questions.qsubtype == 1 || this.questions.DispAnsCol > 1) &&
        !(this.questions.population_type == 3 || this.questions.population_type == 2)) {
        let id = "div_Q" + this.questions.qno + "_" + this.questions.UniqueNumber + "_ID";
        $('#' + id + ' input[type="checkbox"]').prop('checked', false);
        $('#' + id + ' .selectedAnsOpt').removeClass('selectedAnsOpt');

        if ((this.questions.DispAnsCol > 1 || this.questions.qtype == "HR") &&
          this.questions.Answers != null) {
          this.HorizontalAndVerticalHandling();
        }
        this.ngAfterViewInit();
      }
    }
  }

  constructor(private service: ParticipationDataService,  private changeDetect: ChangeDetectorRef,
    private previewData: PreviewData) {
  }

  ngOnInit() {

    if (this.questions == null) {
      this.questions = JSON.parse(this.JsonData);

      this.answerPipingMessageDisplayed();
      this.AsteriskMandatory = this.service.getSurveyMessages().AsteriskMandatory;
      let updateItem = this.questions.Answers.find(
        e => (e.hasImage && e.AnswerImages.length == 2 || e.hasMedia && e.AnswerMedias.length == 2) ||
        (e.hasImage && e.AnswerImages.length == 1 && e.hasMedia && e.AnswerMedias.length == 1));

      if (updateItem != null && updateItem != undefined) {
        this.answerImagesLength = 2;

        if (this.questions.population_type == 3) {
          if (this.questions.selectAnsValue != updateItem.value_id) {
            this.answerImagesLength = 0;
          }
        }

      } else {
        updateItem = this.questions.Answers.find(
          e => (e.hasImage && e.AnswerImages.length == 1 || e.hasMedia && e.AnswerMedias.length == 1));

        if (updateItem != null && updateItem != undefined) {
          this.answerImagesLength = 1;

          if (this.questions.population_type == 3) {
            if (this.questions.selectAnsValue != updateItem.value_id) {
              this.answerImagesLength = 0;
            }
          }
        }
      }

      var hiddenAnswers = this.questions.Answers.filter(e=> e.isHide ==false && e.isQuotaHide == false)
      if(hiddenAnswers.length > 0 && this.questions.qtype == "C" && this.questions.qsubtype == 1)
      {
        this.questions.Answers = hiddenAnswers;
      }

      if(this.questions.population_type ==3)
      {
        if((this.questions.DispAnsCol > 1 || this.questions.qtype == "HR") &&
        this.questions.Answers != null){
          this.questions.Answers=this.questions.Answers.filter(e=>this.CheckInSelectedAnsertList(e.value_id))
        }
        this.answerLength = this.questions.Answers.filter(e => e.isHide == false && e.isADLHide == false && e.ControlAns == true).length;

      }
      else
      {
        this.answerLength = this.questions.Answers.filter(e => e.isHide == false && e.isADLHide == false).length;
      }

      if (this.questions.answer_style == 1 && this.questions.RotateIndex == 0 && this.questions.Answers != null) {
        this.RandomAnswerHandling();
      }

      if ((this.questions.DispAnsCol > 1 || this.questions.qtype == "HR") &&
        this.questions.Answers != null) {
        this.HorizontalAndVerticalHandling();
      }

      if (this.questions.selectedOptionList != null) {
        this.selectedValueList = this.questions.selectedOptionList;
        this.isAnsChange = true;
      }
    }

    // Subscibe To Form Submit/Next Event ( Event is fired when mandatory is not satisfied )
    this.isFormSubmitSub = this.service.emitFormSubmitEvent.subscribe((data) => {
      this.isFormSubmit = data;
    });


    if (this.questions.qtype == "ML") {
      this.answerImagesLength = 0;
    }

    this.isPreview = this.service.GroupType.toUpperCase() == 'PREVIEW';

    this.surveyFormat = this.service.surveyFormat;
    this.isNewParticipation = this.service.isNewParticipation;
    this.newParticipationBtnText = this.service.newParticipationBtnText;
    //this.showNewParticipationButton = this.questions.isMatrixQuestion ==undefined && this.isNewParticipationButton;
    this.showNewParticipationButton = this.isNewParticipationButton;
  }

  ngAfterViewInit() {
    if(window.navigator.userAgent.indexOf("Chrome") != -1) {
      $('.answerParent').css('width', 'calc(100% + 1px)');
      // $('.question-option-wrapper').css('width', 'calc(100% + 1px)');
    }

    var self = this;
    setTimeout(() => {
      $('.image-choice-wrapper').each(function () {
        if ($(this).find('.ic-label').eq(0).hasClass('medium')) {
          $(this).find('.ic-image-holder').addClass('medium');
        } else if ($(this).find('.ic-label').eq(0).hasClass('small')) {
          $(this).find('.ic-image-holder').addClass('small');
        } else {
          $(this).find('.ic-image-holder').addClass('large');
        }

        $(this).find('.ic-image-holder:visible').each(function() {
          if($(this).hasClass('showReportValue')){
            $(this).css('padding-bottom', $(this).find('.ic-report-value:visible').outerHeight() + 'px');
          }
        });

        $(this).find('.ic-image-holder:visible').height($(this).find('.ic-image-holder:visible').outerWidth());
      });
    }, 50);
    $(window).on('resize', function () {
      $('.ic-image-holder:visible').height($('.ic-image-holder:visible').outerWidth());
    });

    if (this.questions.DispAnsCol > 1 && !this.isMobile) {
      $('document').ready(function () {
        for (let i = 0; i < self.questions.Answers.length; i++) {
          let id = "td_Q" + self.questions.qno + "_" + self.questions.UniqueNumber + "_" + self.questions.Answers[i].value_id;
          $('#' + id).unbind().click(function (event) {
            //let checkedValue;
            event.stopPropagation();
            if (!$(this).hasClass('hrb-disabled'))
            {
              // if (($(this).find('input[type="checkbox"]').prop('checked') === false && $(this).find('input[type="checkbox"]').length > 0)) {
              //   $(this).find('input[type="checkbox"]').prop('checked', true);
              //   $(this).addClass('selected');
              //   checkedValue = true;
              // } else {
              //   $(this).find('input[type="checkbox"]').prop('checked', false);
              //   $(this).removeClass('selected');
              //   checkedValue = false;
              // }

              // let currentInputValue = $(this).find('input[type="checkbox"]').attr('value');
              // self.SortValue(currentInputValue, checkedValue, self);
              self.checkboxSelection(self.questions.Answers[i]);
            }
          });
        }

      });
    }

    this.isAriaRequired = (this.questions.mandatory && this.isMandatoryUpfront) || (this.questions.mandatory && this.isFormSubmit && this.questions.isMandatoryInvalid);
    this.isCapchaManditorySkip = this.service.getIsCapchaMandatorySkip();
    this.pageIsSoftRequiredHandle = this.service.getPageIsSoftRequiredHandle();
    this.nextButtonClickNo = this.service.getNextButtonClickNo() == undefined ? 0 : this.service.getNextButtonClickNo();
    this.resetPageSub = this.service.emitResetPageEvent.subscribe((data) => {
      if(data) {
        this.isAnsChange =false;
      }
    });
  }

  ngOnDestroy(){
    this.isFormSubmitSub.unsubscribe();
    if (this.resetPageSub) {
      this.resetPageSub.unsubscribe();
    }
  }

  answerPipingMessageDisplayed(){
    if (this.previewData != undefined && this.service.getPrevPgChnge() && //this.previewData.isPrevPgChnge &&
      this.questions.AnsPipeCondition != 0 && this.questions.AnsPipeCondition != 1 &&
      this.questions.AnsPipeCondition != 3 && this.questions.AnsPipeCondition != 4) {
      this.isDisplayedPipeMessage = true;
    } else {
      this.isDisplayedPipeMessage = false;
    }
    if (this.questions.qtype == "ML") {
      this.answerLength = this.questions.Answers.filter(e => e.isHide == false && e.isADLHide == false).length;
    }
  }

  SortValue(valueId: any, curVal, self) {

    let ans = self.questions.Answers.find(e => e.value_id == valueId);

    if (ans != null && ans != undefined) {
      if (curVal) {
        ans.ControlAns = true;
      } else {
        ans.ControlAns = false;
      }

      this.SelectedValue(ans, curVal);
    }
  }


  RandomAnswerHandling() {
    let currentIndex = this.questions.Answers.length, temporaryValue, randomIndex;
    let updateItem = this.questions.Answers.find(e => e.isOther);

    if (updateItem != undefined && updateItem != null) {
      currentIndex -= 1;
    }

    let isNoneAbove = this.questions.Answers.find(e => e.IsNoneAbove && (e.ControlAns || this.questions.qtype == 'C' || this.questions.qtype == 'ML'));

    if (isNoneAbove != null && isNoneAbove != undefined) {
      currentIndex -= 1;
    }

    // While there remain elements to shuffle...
    while (0 !== currentIndex) {
      // Pick a remaining element...
      randomIndex = Math.floor(Math.random() * currentIndex);
      currentIndex -= 1;

      // And swap it with the current element.
      temporaryValue = this.questions.Answers[currentIndex];
      this.questions.Answers[currentIndex] = this.questions.Answers[randomIndex];
      this.questions.Answers[randomIndex] = temporaryValue;
    }
  }

  HorizontalAndVerticalHandling() {
    let DispAnsCol = this.questions.qtype == "HR" ? 4 : this.questions.DispAnsCol;

    let _isNoneAbove = false;

    let qShowAnswers = this.questions.Answers.filter(e=>e.isADLHide == false)

    _isNoneAbove = qShowAnswers.filter(e => e.IsNoneAbove).length > 0

    let answerLength = qShowAnswers.length;

    let updateItem = qShowAnswers.find(e => e.isOther);

    if ((updateItem != undefined && updateItem != null) && _isNoneAbove) {
      answerLength -= 2;
    }else if ((updateItem != undefined && updateItem != null) || _isNoneAbove) {
      answerLength -= 1;
    }
    let rowCount = Math.ceil(answerLength / DispAnsCol);

    this.columnWidth = (100 / DispAnsCol);

    if (this.questions.DispAnsFormat == 1) {  //Vertical
      let ansArray = [];
      let ansArray1 = [];

      for (let i = 0; i < rowCount; i++) {
        let tempArray = [];
        let index = 0;

        for (let j = i; j < answerLength; j = j + rowCount) {

          tempArray.push(qShowAnswers[j]);

          if (qShowAnswers[j].hasImage || qShowAnswers[j].hasMedia) {
            this.SingleAndMultiImageHandling(index, j);
          }

          index++;
        }

        ansArray.push(tempArray);


      }
      
      if (updateItem != undefined && updateItem != null) {
        let tempArray = [];
        tempArray.push(updateItem);
        ansArray.push(tempArray);
      }
      if (_isNoneAbove) {
        ansArray1.push([qShowAnswers[qShowAnswers.length - 1]]);
        
      }
      this.answersArray = ansArray;
      this.answersArray1 = ansArray1;
      //this.tempArray[0] = ansArray;

    } else if (this.questions.DispAnsFormat == 2 || this.questions.qtype == "HR") { //Horizontal
      let ansArray = [];
      let ansArray1 = [];

      for (let i = 0; i < rowCount; i++) {
        let tempArray = [];
        let counter = 0;
        let index = 0;
        for (let j = (i * DispAnsCol); j < answerLength; j++) {
          counter++;
          tempArray.push(qShowAnswers[j]);

          if (qShowAnswers[j].hasImage ||qShowAnswers[j].hasMedia) {
            this.SingleAndMultiImageHandling(index, j);
          }
          index++;

          if (counter == DispAnsCol) {
            break;
          }
        }

        ansArray.push(tempArray);

      }
      
      if (updateItem != undefined && updateItem != null) {
        let tempArray = [];
        tempArray.push(updateItem);
        ansArray.push(tempArray);
      }
      if (_isNoneAbove) {
        ansArray1.push([qShowAnswers[qShowAnswers.length - 1]]);
      }

      //this.tempArray[0] = ansArray;
      this.answersArray = ansArray;
      this.answersArray1 = ansArray1;
    }

    //this.answersArray = this.tempArray;
  }

  SingleAndMultiImageHandling(index: number, j: number) {
    if ((this.questions.Answers[j].AnswerMedias != null &&
      this.questions.Answers[j].AnswerMedias.length > 1) ||
      (this.questions.Answers[j].AnswerImages != null &&
        this.questions.Answers[j].AnswerImages.length > 1) ||
      this.multiImageArray.indexOf(index) >= 0) {

      if (this.multiImageArray.indexOf(index) < 0) {
        this.multiImageArray.push(index);
      }

      if (this.singleImageArray.indexOf(index) >= 0) {
        this.singleImageArray.splice(this.singleImageArray.indexOf(index), 1);
      }
    } else if ((this.questions.Answers[j].AnswerMedias != null &&
      this.questions.Answers[j].AnswerMedias.length == 1) &&
      (this.questions.Answers[j].AnswerImages != null &&
        this.questions.Answers[j].AnswerImages.length == 1)) {
      if (this.multiImageArray.indexOf(index) < 0) {
        this.multiImageArray.push(index);
      }

      if (this.singleImageArray.indexOf(index) >= 0) {
        this.singleImageArray.splice(this.singleImageArray.indexOf(index), 1);
      }
    }
    else {
      if (this.singleImageArray.indexOf(index) < 0) {
        this.singleImageArray.push(index);
      }
    }

  }

  HasSingleImageClass(index: number): boolean {

    if (this.singleImageArray.indexOf(index) >= 0) {
      return true;
    }
    else {
      return false;
    }
  }

  HasMultiImageClass(index: number): boolean {

    if (this.multiImageArray.indexOf(index) >= 0) {
      return true;
    }
    else {
      return false;
    }
  }

  GetMandatoryState(): boolean {
    if (this.questions != null) {
      return this.questions.mandatory;
    }
  }

  updateselectedValueList(){
    for (let i = 0; i < this.questions.Answers.length; i++) {
      if (this.questions.Answers[i].isADLHide) {
        this.RemoveSelectedList(this.questions.Answers[i]);
      }
    }
  }

  SelectedValue(answer: Answers, event: any) {

    this.questions.isAlertDanger = false;
    let updateItem = this.questions.Answers.find(this.findIndexToUpdate, answer);
    let index = this.questions.Answers.indexOf(updateItem);

    if (event) {
      this.AddSelectedValueList(answer);
      answer.selectdId = 1;
      answer.ControlAns = answer.value_text;
      this.questions.Answers[index] = answer;
      this.questions.pageto = answer.pageto;
      if (this.questions.IsADLRuleApplied) {
        this.updateselectedValueList();
      }
      this.questions.selectedOptionList = this.selectedValueList;

      if (this.questions.isSoftRequired) {
        this.questions.isSoftRequiredHandle = true;
      }

      if (this.questions.ansConstraint != null &&
        this.questions.selectedOptionList.length > 0) {
        this.AnsConstraintHandling();
      } else {
        this.questions.isValid = false;
      }

      if (answer.IsNoneAbove) {
        for (let i = 0; i < this.questions.Answers.length; i++) {
          if (answer.value_id != this.questions.Answers[i].value_id) {
            this.questions.Answers[i].ControlAns = null;
            this.questions.Answers[i].selectdId = 0;
          }
        }
        this.questions.isOtherAnswer=false;
        this.questions.otherAnswer = null;
        this.questions.isValid = false;
        this.questions.isAlertDanger = false;
        this.selectedValueList = [];
        this.questions.selectedOptionList = this.selectedValueList;

        this.AddSelectedValueList(answer);
      } else {
        let isNoneAbove = this.questions.Answers.find(e => e.IsNoneAbove && e.ControlAns);

        if (isNoneAbove != null && isNoneAbove != undefined) {
          let index = this.questions.Answers.indexOf(isNoneAbove);
          this.questions.Answers[index].ControlAns = null;
          this.questions.Answers[index].selectdId = 0;

          this.RemoveSelectedList(this.questions.Answers[index]);
          this.questions.selectedOptionList = this.selectedValueList;

          if (this.questions.ansConstraint != null &&
            this.questions.selectedOptionList.length > 0) {
            this.AnsConstraintHandling();
          } else {
            this.questions.isValid = false;
          }
        }
      }

      if (answer.isOther) {
        this.questions.isOtherAnswer = true;
        let id = this.questions.UniqueNumber + '_txt_other';
        let control = document.getElementById(id);

        setTimeout(function () {
          control.focus();
        }, 0);
      }
    }
    else {
      this.RemoveSelectedList(answer);

      answer.selectdId = 0;
      answer.ControlAns = null;

      this.questions.selectedOptionList = this.selectedValueList;

      if (this.questions.ansConstraint != null &&
        this.questions.selectedOptionList.length > 0) {
        this.AnsConstraintHandling();
      } else {
        this.questions.isValid = false;
      }

      if (answer.IsNoneAbove) {
        this.questions.isValid = false;
      }

      this.questions.Answers[index] = answer;
      this.questions.AnswerID = 0;
      this.questions.selectAnsValue = 0;

      if (this.questions.selectedOptionList != null && this.questions.selectedOptionList.length == 0) {
        this.questions.pageto = 0;
      }

      if (this.questions.isSoftRequired) {
        this.questions.isSoftRequiredHandle = false;
      }

      if (answer.isOther) {
        this.questions.isOtherAnswer = false;
        this.questions.otherAnswer = null;
      }
    }

    if (this.selectedValueList.length > 0) {
      this.questions.AnswerText = "Selected Answer Option";
    } else {
      this.questions.AnswerText = null;
    }
    this.changeDetect.detectChanges();
    this.service.setQuestionChange(this.questions);
    this.ChangeAnswersData.emit(this.questions);
    this.isAnsChange = true;
  }

  AddSelectedValueList(answer: Answers) {
    let selectedList = this.selectedValueList.find(e => e.value_id == answer.value_id);

    if (this.selectedValueList.indexOf(selectedList) < 0) {
      this.selectedValueList.push({ value_id: answer.value_id, value_text: answer.value_text, isOther: answer.isOther });
    }
  }

  RemoveSelectedList(answer: Answers) {
    let selectedList = this.selectedValueList.find(e => e.value_id == answer.value_id);

    let curIndex = this.selectedValueList.indexOf(selectedList);

    if (curIndex >= 0) {
      this.selectedValueList.splice(curIndex, 1);
    }
  }

  AnsConstraintHandling() {
    let ansCons = this.questions.ansConstraint.split(' ');

    if (ansCons[0] == '=') {
      if (this.questions.selectedOptionList.length == parseInt(ansCons[1])) {
        this.questions.isValid = false;
        this.questions.isAlertDanger = false;
      } else {
        this.questions.isValid = true;
        this.questions.isAlertDanger = true;
      }
    } else if (ansCons[0] == '>=') {
      if (this.questions.selectedOptionList.length >= parseInt(ansCons[1])) {
        this.questions.isValid = false;
        this.questions.isAlertDanger = false;
      } else {
        this.questions.isValid = true;
        this.questions.isAlertDanger = true;
      }
    } else if (ansCons[0] == '<=') {
      if (this.questions.selectedOptionList.length <= parseInt(ansCons[1])) {
        this.questions.isValid = false;
        this.questions.isAlertDanger = false;
      } else {
        this.questions.isValid = true;
        this.questions.isAlertDanger = true;
      }
    }
  }

  findIndexToUpdate(answer) {
    return answer === this;
  }

  GetQuestionsString(question: Questions, index: number): string {
    return JSON.stringify(question);
  }

  UpdateQuestionsData(question: Questions) {
    this.ChangeAnswersData.emit(question);
    this.isAnsChange = true;
  }

  checkInput(event) {
    if ($(event.target).find('input').prop('checked') == false) {
      if ($(event.target).find('input').attr('type') == "radio") {
        $(event.target).parents('.image-choice-wrapper').find('input').prop('checked', false);
      }
      $(event.target).find('input').prop('checked', true);
    } else {
      $(event.target).find('input').prop('checked', false);
    }

    let val = $(event.target).find('input').attr('ng-reflect-value');
    console.log($(event.target).find('input').attr('ng-reflect-value'));

  }

  getAnsImageMediaCSS(answer: Answers) {

    if ((answer.hasImage == true && answer.AnswerImages.length == 1 && answer.hasMedia == false) ||
      (answer.hasMedia == true && answer.AnswerMedias.length == 1 && answer.hasImage == false)) {
      return 'single-ans-image';
    }
    else if ((answer.hasImage == true && answer.AnswerImages.length == 1) &&
      (answer.hasMedia == true && answer.AnswerMedias.length == 1)) {
      return 'multi-ans-image';
    }
    else if ((answer.hasImage == true && answer.AnswerImages.length == 2) ||
      (answer.hasMedia == true && answer.AnswerMedias.length == 2)) {
      return 'multi-ans-image';
    }
  }

  onBlurMethod() {
    if (this.questions.AnswerText == "") {
      this.questions.AnswerText = null;
    }
    this.service.setQuestionChange(this.questions);
    this.ChangeAnswersData.emit(this.questions);
    this.isAnsChange = true;
  }

  loadInlineQDL(rule_Id: number) : Questions{
    if (this.questions.rules != null && this.questions.rules.length > 0) {
      this.nextButtonClickNo = this.service.getNextButtonClickNo();
      let updateItem = this.questions.rules.filter(e => e.Rule_id == rule_Id && e.InlineQDL);

      if (updateItem != null && updateItem != undefined) {
       return this.newInlineQDLHandling(updateItem);
      }
    }

    return null;
  }

  newInlineQDLHandling(rule: Rules[]): Questions {
    for (let k = 0; k < rule.length; k++) {
    let value = rule[k].ConditionValue.split(',');

    if (value != undefined && value != null) {
      let count: number = 0;
      for (let i = 0; i < value.length; i++) {

        if (this.questions.selectedOptionList != null && this.questions.selectedOptionList.indexOf(
          this.questions.selectedOptionList.find(e => e.value_id == parseInt(value[i]))) >= 0) {
          count++;
        }
      }

      if(this.newOperatorValid(rule[k], count, value) != null)
        {
           return this.newOperatorValid(rule[k], count, value);
        };
    }
    }
  }

  newOperatorValid(updateItem: Rules, count: number, value: any) : Questions{
    if (updateItem.Operator == 'AND' && count == value.length) {
      return this.newLoadQDL(updateItem);
    } else if (updateItem.Operator == 'OR' && count <= value.length && count != 0) {
      return this.newLoadQDL(updateItem);
    } else if (updateItem.Operator == 'NOT' && count == 0) {
      return this.newLoadQDL(updateItem);
    } else if ((updateItem.Operator == 'ISANSWERED' && this.questions.selectedOptionList != null)) {
      return this.newLoadQDL(updateItem);
    } else if ((updateItem.Operator == 'ISNOTANSWERED' 
    && (this.questions.selectedOptionList == null || this.questions.selectedOptionList.length == 0))) {
      return this.newLoadQDL(updateItem);
    } else {
      return null;
    }
  }

  newLoadQDL(updateItem: Rules) : Questions {
    let qn = this.service.GetQDL(updateItem.ConditionQID);

    if (qn != undefined && qn != null) {
      if (!qn.isLoading) {
        qn.isLoading = true;
        this.ChangeLoadingAnswersData.emit(qn);
      }
    }
    return this.service.GetQDL(updateItem.ConditionQID);
  }

  loadDestinationQn(rule_Id: number): Questions {

    if (this.questions.DestinationQuestions != null &&
      this.questions.DestinationQuestions != undefined) {

      if (this.questions.DestinationQuestions.find(e => e.rule_id == rule_Id) != undefined) {
        let qn = this.service.GetQDL(this.questions.DestinationQuestions.find(e => e.rule_id == rule_Id).ConditionQID);

        if (qn != undefined && qn != null) {
          if (!qn.isLoading) {
            qn.isLoading = true;
            this.ChangeLoadingAnswersData.emit(qn);
          }
        }

        return this.service.GetQDL(this.questions.DestinationQuestions.find(e => e.rule_id == rule_Id).ConditionQID);
      } else {
        return null;
      }
    }
  }

  gotoNextQuestion(question: Questions, event: any) {
    if (this.isStandAlone) {
      var nextbtnLength = $(event).closest('.active-ques').nextAll('.inactive-ques').has('.question-data').length;

        var elemPosition;
        elemPosition = $(event).closest('.matrix-standalone-active-ques' + question.group_no).nextAll('.matrix-standalone-active-ques' + question.group_no)
        var MatrixelemPosition;
        var MatrixelemPosition1;
      if (this.questions.isMatrixQuestion != undefined) {
        MatrixelemPosition = $(event).closest('.matrix-mobile-subQ_' + this.group.Matrix_id).nextAll('.matrix-mobile-subQ_' + this.group.Matrix_id)
        //MatrixelemPosition = $(event).closest('.matrix-mobile-subQ_' + this.group.Matrix_id)
        MatrixelemPosition1 = $(event).closest('.matrix-mobile-subQ-cont').nextAll('.matrix-mobile-subQ-cont')
      }
        if (elemPosition.length > 0) {
          elemPosition = $(event).closest('.matrix-standalone-active-ques' + question.group_no).nextAll('.matrix-standalone-active-ques' + question.group_no).has('.question-data').eq(0).offset().top;
          $('html,body').animate({
            scrollTop: (elemPosition - $(window).height() / 3)
          }, 400);
        }else if (this.questions.isMatrixQuestion != undefined && MatrixelemPosition.length > 0) {
          MatrixelemPosition = $(event).closest('.matrix-mobile-subQ_' + this.group.Matrix_id).nextAll('.matrix-mobile-subQ_' + this.group.Matrix_id).has('.question-data').eq(0).offset().top;
          //MatrixelemPosition = $(event).closest('.matrix-mobile-subQ_' + this.group.Matrix_id).has('.question-data').eq(0).offset().top;
          $('html,body').animate({
            scrollTop: (MatrixelemPosition - $(window).height() / 3)
          }, 400);
        }else if (this.questions.isMatrixQuestion != undefined && MatrixelemPosition1.length > 0) {
          //MatrixelemPosition = $(event).closest('.matrix-mobile-subQ_' + self.group.Matrix_id).nextAll('.matrix-mobile-subQ_' + self.group.Matrix_id).has('.question-data').eq(0).offset().top;
          //MatrixelemPosition = $(event).nextAll('.matrix-mobile-subQ_' + self.group.Matrix_id).has('.question-data').eq(0).offset().top;
          MatrixelemPosition1 = $(event).closest('.matrix-mobile-subQ-cont').nextAll('.matrix-mobile-subQ-cont').has('.question-data').eq(0).offset().top;
          $('html,body').animate({
            scrollTop: (MatrixelemPosition1 - $(window).height() / 3)
          }, 400);
        } else if (nextbtnLength > 0) {
          elemPosition = $(event).closest('.active-ques').nextAll('.inactive-ques').has('.question-data').eq(0).offset().top;
          $('html,body').animate({
            scrollTop: (elemPosition - $(window).height() / 3)
          }, 400);
        }else{
          var scrollVal = $('.tblPageFooter').offset().top;
          $('html,body').animate({
            scrollTop: scrollVal
          }, 400);
        }
    } else {
      this.service.gotoNextQuestion(question, event);
    }
  }

  checkboxSelection(answer: Answers) {
    if (answer.selectdId == 0) {
      this.SelectedValue(answer, true);
    } else {
      this.SelectedValue(answer, false);
    }
  }

  gotoNextQuestionKeyboard(question,event) {
    event.preventDefault();
    this.gotoNextQuestion(question,event.target);
  }

  getAnswerPipeMessage(): string{
    return this.service.getAnswerPipeMessage();
  }

  CheckInSelectedAnsertList(value_id: any):boolean{

    if(this.questions.selectedOptionList && this.questions.selectedOptionList.find(e => e.value_id == value_id) != undefined)
    {
      return true;
    }
    else
    {
      return false;
    }

  }
}

